import { validator } from './validator';
import { formatCurrency } from './formatCurrency';

export const required = validator({
  message: 'Este campo es requerido',
  validate: (value) => (
    typeof value === 'string' 
      ? value !== undefined && value.trim() !== ''
      : value !== undefined
  )
});

export const phone = validator({
  message: 'Número de teléfono inválido',
  validate: (value: string) => value !== '' ?  /^\d{10,}$/.test(value) : true
});

export const email = validator({
  message: 'Correo electrónico inválido',
  validate: (value: string) => (
    value !== ''
      ? /^[\d\w-]{2,}@[\d\w]{2,}\.[\d\w]{2,}$/.test(value)
      : true
  )
});

export const username = validator({
  message: 'El nombre de usuario solo puede contener: letras, números, guiones (-_), @ y puntos',
  validate: (value) => (
    /^[\w@\-.]{4,30}$/.test(value) && 
    !/^[.\-_\d]/.test(value) &&
    !/[.\-_]$/.test(value) &&
    !/[.\-_]{2,}/.test(value)
  )
});

export const cedula = validator({
  message: 'Número de cédula inválido',
  validate: (value: string) => {

    if (!/^\d{11}$/.test(value)) return false;

    let sum = 0;

    for (let index = 0; index < 10; index++) {
      const product = Number(value[index]) * (index % 2 === 0 ? 1 : 2);
      sum += product > 9 ? product - 9 : product;
    }

    return (10 - sum % 10) % 10 === Number(value[10]);
  }
});

export const passport = validator({
  message: 'Número de pasaporte inválido',
  validate: (value: string) => /^[A-Z0-9]{6,9}$/i.test(value.trim())
});

export const min = (min: number) => validator({
  deps: min,
  message: `Monto mínimo ${formatCurrency(min)}`,
  validate: (value: string) => parseInt(value) >= min
});

export const max = (max: number) => validator({
  deps: max,
  message: `Monto máximo ${formatCurrency(max)}`,
  validate: (value: string) => parseInt(value) <= max
});

export const length = (length: number, message: string) => validator({
  deps: length,
  message,
  validate: (value: string) => value.length >= length
});

export const maxLength = (length: number, message: string) => validator({
  deps: length,
  message,
  validate: (value: string) => value.length <= length
});

export const equal = (text: string, message?: string) => validator({
  deps: text,
  message: message || 'Los valores no son iguales',
  validate(value: string) {
    return value === text;
  }
});

export const regex = (regex: RegExp, message?: string) => validator({
  deps: regex,
  message: message || 'Valor invalido',
  validate: (value: string) => regex.test(value)
});
